import { render, staticRenderFns } from "./EmailCheckAttempt.vue?vue&type=template&id=447bbd58&scoped=true"
import script from "./EmailCheckAttempt.vue?vue&type=script&lang=js"
export * from "./EmailCheckAttempt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447bbd58",
  null
  
)

export default component.exports